import React, { useState , useContext} from 'react'
import axios from "axios";
import { Check, X } from 'lucide-react';
import "./StatusChange.css"
import { GlobalContext } from '../../Context/GlobalState';
import { BASE_URL_APISERVICES } from '../../utils/Constants';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import { adminAuth } from '../../config';

const TXN_TYPES = [
    { value: "BBPS_OFFLINE", label: "BBPS Offline" },
    { value: "AEPS_SETTLEMENT", label: "AEPS Settlement" },
    { value: "PG_SETTLEMENT", label: "PG Settlement" },
    { value: "AEPS_CW", label: "AEPS Cash Withdrawal" },
    { value: "VENDOR_PAYMENT", label: "Vendor Payment" }
   
];




export default function StatusChange() {
    const { setTransactionLoaderState , user} = useContext(GlobalContext);
    const { username1, password1 } = adminAuth;

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("success");
    const [modalMessage, setModalMessage] = useState("");

    const initialState = {
        adminId: user.pkid,
        transactionType: "",
        transactionId: "",
        status: "",
        remark: "",
        rrn: ""
    };
    const [formData, setFormData] = useState(initialState);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };





    const validateForm = () => {
        const newErrors = {};
        if (!formData.transactionType) newErrors.transactionType = "Please select Transaction Type";
        if (!formData.transactionId.trim()) newErrors.transactionId = "Transaction ID is required";
        if (!formData.status) newErrors.status = "Please select status";
        if (!formData.remark.trim()) newErrors.remark = "remark is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };




    const resetForm = () => {
        setFormData(initialState);
        setErrors({});
    };



    const handleSubmit = async () => {
        if (loading) return;
        if (!validateForm()) return;

        setLoading(true);

        try {
          const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
                );
                


            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(formData),
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${API_ENDPOINTS.STATUS_CHANGE}`,
                requestOptions
            );

            const data = await res.json();

            if (data?.responseCode === "00") {
                setModalType("success");
                setModalMessage(data.responseMessage || "Transaction updated successfully");
                setShowModal(true);
                resetForm();

            } else {
                setModalType("error");
                setModalMessage(data?.responseMessage || "Transaction update failed");
                setShowModal(true);
            }

        } catch (error) {
            console.error("API ERROR:", error);
            setModalType("error");
            setModalMessage(error?.message || "Server error occurred");
            setShowModal(true);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="sc-container">
            <div className="sc-card">
                <h1 className="sc-title">Status Change</h1>
                <p className="sc-subtitle">Update transaction records instantly</p>

                <div className="sc-form-container">
                    <div className="sc-form-group">
                        <label className="sc-label">Transaction Type</label>
                        <select
                            name="transactionType"
                            className="sc-select"
                            value={formData.transactionType}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Choose Transaction Type</option>
                            {TXN_TYPES.map(type => (
                                <option key={type.value} value={type.value}>{type.label}</option>
                            ))}
                        </select>
                        {errors.transactionType && <p className="sc-error-msg">{errors.transactionType}</p>}
                    </div>

                    <div className="sc-form-group">
                        <label className="sc-label">Transaction ID</label>
                        <div className="cc-input-group">

                            <input
                                name="transactionId"
                                type="text"
                                className="cc-input"
                                placeholder="Enter ID"
                                value={formData.transactionId}
                                onChange={handleChange}
                            />
                        </div>
                        {errors?.transactionId && <p className="sc-error-msg"> {errors.transactionId}</p>}
                    </div>


                    <div className="sc-form-group">
                        <label className="sc-label">Action To Perform</label>
                        <select
                            name='status'
                            className="sc-select"
                            style={{ color: formData.status === 'FAILED' ? '#ef4444' : formData.status === 'SUCCESS' ? '#10b981' : 'inherit' }}
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Choose Status</option>
                            <option value="SUCCESS">Approve Transaction</option>
                            <option value="FAILED">Reject Transaction</option>
                            <option value="PENDING">Mark as Pending</option>
                        </select>
                        {errors?.status && <p className="sc-error-msg"> {errors.status}</p>}
                    </div>


                    <div className="sc-form-group">
                        <label className="sc-label">Remark / Reason</label>
                        <input
                            name='remark'
                            type="text"
                            className="sc-input"
                            placeholder="Provide a brief reason..."
                            value={formData.remark}
                            onChange={handleChange}
                        />
                        {errors?.remark && <p className="sc-error-msg"> {errors.remark}</p>}
                    </div>

                    <div className="sc-form-group">
                        <label className="sc-label">RRN</label>
                        <input
                            name='rrn'
                            type="text"
                            className="sc-input"
                            placeholder="Enter RRN"
                            value={formData.rrn}
                            onChange={handleChange}
                        />
                    </div>

                    <button className="sc-btn-submit" onClick={handleSubmit} disabled={loading}>
                        {loading ? "Processing..." : "SUBMIT"}
                    </button>
                </div>
            </div>


            {showModal && (
                <div className="fa-modal-overlay">
                    <div className="fa-modal-content">
                        <div style={{
                            width: '70px', height: '70px', borderRadius: '50%',
                            backgroundColor: modalType === "success" ? '#ecfdf5' : '#fff1f2',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}>
                            {modalType === "success" ? (
                                <Check size={32} color="#10b981" strokeWidth={3} />
                            ) : (
                                <X size={32} color="#ef4444" strokeWidth={3} />
                            )}
                        </div>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>
                            {modalType === "success" ? "All Set!" : "Request Failed"}
                        </h3>
                        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '2rem' }}>
                            {modalMessage}
                        </p>
                        <button
                            className="fa-btn"
                            style={{ background: modalType === "success" ? '#10b981' : '#ef4444', marginTop: 0 }}
                            onClick={() => { setShowModal(false); resetForm(); }}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}